"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const LoadingService_1 = require("../Services/LoadingService");
const react_bootstrap_1 = require("react-bootstrap");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_router_dom_1 = require("react-router-dom");
const ApiService_1 = require("../Services/ApiService");
const utilities_1 = require("../assets/utilities/utilities");
const ToastService_1 = require("../Services/ToastService");
const MyEquipmentPage = () => {
    const { startLoading, stopLoading } = (0, react_1.useContext)(LoadingService_1.LoadingContext);
    const [matricola, setMatricola] = react_1.default.useState();
    const [products, setProducts] = react_1.default.useState();
    const [categories, setCategories] = react_1.default.useState(['pantaloni', 'casacca', 'pile']);
    const { showToast } = (0, react_1.useContext)(ToastService_1.ToastContext);
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(() => {
        startLoading();
        const fetchData = async () => {
            try {
                const [userDataFetch, categoriesFetch, productsFetch] = await Promise.all([
                    (0, ApiService_1.fetchUserData)(),
                    (0, ApiService_1.fetchCategories)(),
                    (0, ApiService_1.fetchProducts)(),
                ]);
                console.log(productsFetch);
                setMatricola(userDataFetch.matricola);
                setCategories(categoriesFetch.data);
                setProducts(productsFetch);
                stopLoading();
            }
            catch (error) {
                stopLoading();
                if (error.message === 'Error: 400') {
                    showToast('danger', 'Errore', 'Matricola non trovata. Contatta l\'ufficio comunicazione', 5000);
                    return;
                }
            }
        };
        fetchData();
    }, []);
    function goToReport(id) {
        window.scrollTo(0, 0);
        navigate('/segnalazione/' + id);
    }
    function goToSearch(id) {
        window.scrollTo(0, 0);
        navigate('/ricerca-divisa/' + id);
    }
    return (react_1.default.createElement("div", { className: "container p-0" },
        react_1.default.createElement("h1", { className: "title my-0" }, "La mia dotazione"),
        matricola && react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", { className: "mt-2" },
                "N. Maticola ",
                react_1.default.createElement("span", { className: "fw-bold" }, matricola)),
            react_1.default.createElement("p", null, "Ecco la tua dotazione al completo"),
            react_1.default.createElement("hr", null)),
        categories.map((category) => {
            const filteredProducts = Array.isArray(products)
                ? products.filter((product) => product.category === category)
                : [];
            if (filteredProducts.length > 0) {
                return (react_1.default.createElement("div", { key: category },
                    react_1.default.createElement("h3", { className: "text-capitalize fw-bold h5" }, category),
                    react_1.default.createElement(react_bootstrap_1.Accordion, { className: "mb-5" }, filteredProducts.map((product) => (react_1.default.createElement(react_bootstrap_1.Accordion.Item, { eventKey: `${category}_${product.id}`, key: product.id, className: "mb-3 br-20" },
                        react_1.default.createElement(react_bootstrap_1.Accordion.Header, null,
                            react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center w-100 gap-5" },
                                react_1.default.createElement("div", { className: "d-flex gap-2 align-items-center" },
                                    react_1.default.createElement("div", { className: "w-50" },
                                        react_1.default.createElement("img", { className: "overflow-hidden br-10", width: 50, src: (0, utilities_1.returnImageCorrect)(product.category), alt: "Pantaloni" })),
                                    react_1.default.createElement("div", { className: "h6 fw-bold mb-0" }, product.name)),
                                react_1.default.createElement("div", { className: "pe-3 text-primary fw-bold text-nowrap" },
                                    react_1.default.createElement("span", { className: "fs-3" }, product.used_credits),
                                    " /",
                                    ' ',
                                    product.max_credits))),
                        react_1.default.createElement(react_bootstrap_1.Accordion.Body, null,
                            react_1.default.createElement("hr", null),
                            react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center gap-5" },
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement("div", { className: "label fw-bold text-black" }, "Data ritiro"),
                                    react_1.default.createElement("p", { className: "mb-0" }, product.collection_date ? new Date(product.collection_date).toLocaleDateString("it-IT") : '-')),
                                react_1.default.createElement("div", { className: "d-flex gap-3" },
                                    react_1.default.createElement("div", null,
                                        react_1.default.createElement("div", { className: "label fw-bold text-black" }, "Taglia"),
                                        react_1.default.createElement("p", { className: "mb-0" }, product.size)),
                                    react_1.default.createElement("div", null,
                                        react_1.default.createElement("button", { className: "btn-icon-secondary", onClick: () => goToSearch(product.id) },
                                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faSearch }))))),
                            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", className: "w-100 mt-3 br-10 fw-bold", onClick: () => goToReport(product.id) }, "Segnala"))))))));
            }
        })));
};
exports.default = MyEquipmentPage;
